import {LayoutModule} from '@angular/cdk/layout';
import {HTTP_INTERCEPTORS} from '@angular/common/http';
import {Injector, NgModule} from '@angular/core';
import {HttpClientModule} from '@angular/common/http';
import {TranslateModule} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {FlexLayoutModule} from '@angular/flex-layout';
import {BrowserModule, Title} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {
  LocalStorageService,
  NgxWebstorageModule,
  SessionStorageService,
} from 'ngx-webstorage';
import {JhiEventManager} from 'ng-jhipster';
import {MatBadgeModule} from '@angular/material/badge';
// @ts-ignore
import {InfiniteScrollModule} from 'ngx-infinite-scroll';

import {AppRoutingModule} from '@app/app-routing.module';
import {AppComponent} from '@app/app.component';
import {
  ErrorComponent,
  FooterComponent,
  PageRibbonComponent,
  NotificationPopupComponent,
  NotificationDialogComponent,
  CanhTacControlEnvironmentDialogComponent,
  CanhTacControlEnvironmentPopupComponent,
} from '@app/layouts';
import {SharedModule} from '@app/shared';
import {CoreModule} from '@app/core';
import {AccountModule} from '@app/account/account.module';
import {EntityModule} from '@entities/entity.module';
import {NotificationInterceptor} from '@app/blocks/interceptor/notification.interceptor';
import {ErrorHandlerInterceptor} from '@app/blocks/interceptor/errorhandler.interceptor';
import {AuthExpiredInterceptor} from '@app/blocks/interceptor/auth-expired.interceptor';
import {AuthInterceptor} from '@app/blocks/interceptor/auth.interceptor';
import {HomeModule} from '@app/home';
import {LoadingScreenInterceptor} from '@app/blocks/interceptor/loading-screen.interceptor';
import {SidebarComponent} from '@layouts/sidebar/sidebar.component';
import {AdminModule} from '@app/admin/admin.module';
import {UnitRegisterModule} from '@app/unit';

// setup firebase
import {AngularFireModule} from '@angular/fire/compat';
import {AngularFireAnalyticsModule} from '@angular/fire/compat/analytics';
// import { AngularFirestoreModule } from '@angular/fire/compat/firestore';
import {AngularFireMessagingModule} from '@angular/fire/compat/messaging';

import {environment} from 'src/environments/environment';
import {ChartsModule} from 'ng2-charts';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
@NgModule({
  declarations: [
    AppComponent,
    NotificationPopupComponent,
    NotificationDialogComponent,
    CanhTacControlEnvironmentDialogComponent,
    CanhTacControlEnvironmentPopupComponent,
    ErrorComponent,
    PageRibbonComponent,
    FooterComponent,
    SidebarComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    AppRoutingModule,
    LayoutModule,
    NgxWebstorageModule.forRoot({prefix: 'pmw', separator: '-'}),
    SharedModule,
    CoreModule,
    HomeModule,
    AccountModule,
    EntityModule,
    AdminModule,
    UnitRegisterModule,
    MatBadgeModule,
    AngularFireModule.initializeApp(environment.firebase),
    AngularFireAnalyticsModule,
    AngularFireMessagingModule,
    ChartsModule,
    InfiniteScrollModule,
    MatSlideToggleModule,
    HttpClientModule,
    TranslateModule.forRoot(),
  ],
  entryComponents: [
    NotificationPopupComponent,
    NotificationDialogComponent,
    CanhTacControlEnvironmentDialogComponent,
    CanhTacControlEnvironmentPopupComponent,
  ],
  providers: [
    Title,
    ...provideTranslateHttpLoader(),
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
      deps: [LocalStorageService, SessionStorageService],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthExpiredInterceptor,
      multi: true,
      deps: [Injector],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorHandlerInterceptor,
      multi: true,
      deps: [JhiEventManager],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: NotificationInterceptor,
      multi: true,
      deps: [Injector],
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoadingScreenInterceptor,
      deps: [Injector],
      multi: true,
    },
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
